import { Layout } from '@/data/types/Layout';

export const getSearchStorePage = (): Layout => ({
	name: 'DoubleStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'SearchStore', id: 'search-store' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
